<public-header-component></public-header-component>

<section class="login-section">
  <div class="login-section-inner">
    <!-- <div class="login-left">
      <h2 class="text-center">Welcome!</h2>
      <h3><strong>Shippers</strong> </h3>
      <h5> Please, sign in to get freight quotations from multiple providers. Its FREE.</h5>
      <h3><strong>Freight Forwarders & Port Suppliers</strong></h3>
      <h5>Please, sign in to view multiple Ro-Ro schedules and the world's only transparent port calendar,</h5>
      <h5>showing all current and planned Ro-Ro schedules.</h5>
      <div>
        <div class="ad-banner-container">
          <h5 class="ad-banner-heading mb-3">30-day free trial</h5>
          <h5 class="ad-banner-subheading mb-3">Join now and get a free 30-day membership.</h5>
          <a class="ad-banner-btn" href="{{registerUrl}}">Try now</a>
        </div>
      </div>

    </div> -->
    <div class="login-right">
      <div>
        <form class="form-card" [formGroup]="loginForm">
          <div class="row">
            <div class="col-md-12">
              <img src="../../../assets/images/enl-solutions-logo-new.png" class="login-logo enl-logo" />
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <div class="section-relative">
                  <input type="email" formControlName="userName" class="form-control" id="InputEmail"
                    aria-describedby="emailHelp" placeholder="Enter Email" />
                  <img src="../../../../assets/images/user.svg" class="user-icon" />

                  <div *ngIf="hasError('userName', 'required') && submitted" class="invalid-Validation">
                    Email is required
                  </div>
                  <div *ngIf="hasError('userName', 'email') && submitted" class="invalid-Validation">
                    Invalid Email
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <div class="section-relative">
                  <input id="exampleInputPassword1" formControlName="password" class="form-control" pTooltip="Passwords must contain at least eight characters." tooltipPosition="left" placeholder="Enter Password"
                    type="password" required />
                  <img src="../../../../assets/images/password.svg" class="user-icon pass-icon" />

                  <div *ngIf="hasError('password', 'required') && submitted" class="invalid-Validation">
                    Password is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="remember-sec">
                <label class="container">Remember me
                  <input type="checkbox" formControlName="remember" />
                  <span class="checkmark"></span>
                </label>

                <div class="forgot-pass">
                  <a routerLink="/forgotpassword">Forgot Password</a>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="btn-login-sec">
                <button class="btn btn-signIn" type="submit" (click)="Login()">
                  SIGN IN
                </button>
                <a routerLink="/signup" class="btn btn-signIn btn-signUp">
                  REGISTER
                </a>
              </div>
            </div>
            <div class="col-md-12">
              <div class="copyright-text">
                Copyright 2019. All Rights Reserved.
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
